var EnvironmentTypes;
(function (EnvironmentTypes) {
    EnvironmentTypes["Development"] = "development";
    EnvironmentTypes["Production"] = "production";
})(EnvironmentTypes || (EnvironmentTypes = {}));

export { EnvironmentTypes };
